import type { Column } from '@tanstack/react-table';
import { Box, Checkbox, DropdownFilter } from '@ksyos/design-system';
import { getSelectedLanguage } from '@frontend/translate';

type ColumnDropdownFilterProps<T> = {
    column: Column<T, unknown>;
    sortedUniqueValues: [string, number][];
};

export function ColumnDropdownFilter<T>({ column, sortedUniqueValues }: Readonly<ColumnDropdownFilterProps<T>>) {
    const translate = getSelectedLanguage();

    return (
        <DropdownFilter
            count={((column.getFilterValue() as string[]) || []).length}
            label={`${translate.common.filterOnSingular} ${column.columnDef.id ?? column.columnDef.header}`}
            onReset={() => {
                column.setFilterValue([]);
            }}
            width="full"
        >
            {sortedUniqueValues.map(([value, amount]) => (
                <Box
                    display="flex"
                    key={value}
                    pb={2}
                >
                    <Checkbox
                        checked={((column.getFilterValue() as string[]) || []).includes(value)}
                        label={`${value} (${amount})`}
                        onChange={(event) => {
                            const updatedTypeFilters = [...((column.getFilterValue() as string[]) || [])];
                            if (event.target.checked) {
                                updatedTypeFilters.push(value);
                            } else {
                                const index = updatedTypeFilters.indexOf(value);
                                updatedTypeFilters.splice(index, 1);
                            }
                            column.setFilterValue(updatedTypeFilters);
                        }}
                    />
                </Box>
            ))}
        </DropdownFilter>
    );
}
